import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/applications/manual-voucher-confirmation/list')({
  staticData: {
    meta: {
      title: 'Заявки на подтверждение фиксации',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/applications/manual-voucher-approval" />
}
